import { createActionGroup, emptyProps, props } from "@ngrx/store";
import {
    AdmByStdInterface,
    AdminDashboardSummaryInterface,
    DashboardActivtyInterface,
    FeesByStdInterface,
    FeesPaymentTrendInterface,
} from "../../interfaces";

export const dashboardActions = createActionGroup({
    source: "dashboard",
    events: {
        "get admin dashboard summary": () => emptyProps(),
        "set admin dashboard summary": props<{ data: AdminDashboardSummaryInterface }>(),
        "get admin dashboard activities": () => emptyProps(),
        "set admin dashboard activities": props<{
            data: DashboardActivtyInterface;
        }>(),
        "get admin fees by std": () => emptyProps(),
        "set admin fees by std": props<{ data: FeesByStdInterface[] }>(),
        "get admin fees payment trend": () => emptyProps(),
        "set admin fees payment trend": props<{ data: FeesPaymentTrendInterface[] }>(),
        "get admin adm by std": () => emptyProps(),
        "set admin adm by std": props<{ data: AdmByStdInterface[] }>(),
    },
});
